<template>
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54 48H18"
      stroke="currentcolor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 9H66"
      stroke="currentcolor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 63H66"
      stroke="currentcolor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.4853 27.5147C31.1716 32.201 31.1716 39.799 26.4853 44.4853C21.799 49.1716 14.201 49.1716 9.51472 44.4853C4.82842 39.799 4.82842 32.201 9.51472 27.5147C14.201 22.8284 21.799 22.8284 26.4853 27.5147"
      stroke="currentcolor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M62.4852 27.5147C67.1715 32.201 67.1715 39.799 62.4852 44.4853C57.7989 49.1716 50.2009 49.1716 45.5146 44.4853C40.8283 39.799 40.8283 32.201 45.5146 27.5147C50.2009 22.8284 57.7989 22.8284 62.4852 27.5147"
      stroke="currentcolor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
